import React, { FunctionComponent } from 'react';
import AgencyCard, { AgencyCardProps } from '../agency-card/AgencyCard';
import * as styles from './AgencyCardList.style';

export interface AgencyCardListProps {
  items: (AgencyCardProps & {
    id: string | number,
  })[],
}

const AgencyCardList: FunctionComponent<AgencyCardListProps> = ({
  items,
}) => (
  <ul>
    {items.map((item) => (
      <li
        key={item.id}
        css={styles.item}
      >
        <AgencyCard
          {...item}
        />
      </li>
    ))}
  </ul>
);

export default AgencyCardList;
